const IndividualUser = () => {
  return <div>Individual User</div>;
};

export default IndividualUser;
